import React from 'react';

import {Preloader} from '../../../components/preloader/preloader';
import {Sidebar} from '../../../components/layout/sidebar';
import {useDraftQueries} from './hooks/use-draft-queries';

import {QueryLink} from './query-link';
import {QueriesSidebarProps} from './interface';
import {SidebarHeader} from '../../../components/layout/sidebar/sidebar-header/sidebar-header';
import {numericSortComparator} from '../../../utils/array';
import {EmptyList} from '../../../components/empty-list/empty-list';

export function QueryDraftsSidebar(props: QueriesSidebarProps) {
    const draftQueries = useDraftQueries();

    const draftQueriesSorted = React.useMemo(
        () => draftQueries.data?.sort(numericSortComparator('createdAt')),
        [draftQueries.data]
    );

    return (
        <Sidebar
            header={<SidebarHeader title="Draft queries" onClose={props.closeSidebar} />}
            border="right"
        >
            <Preloader show={draftQueries.isLoading}>
                {draftQueriesSorted && (
                    <>
                        {draftQueriesSorted.length === 0 && <EmptyList message="No drafts found" />}

                        {draftQueriesSorted.map((queryDraft) => (
                            <QueryLink
                                key={queryDraft.id}
                                queryId={queryDraft.id}
                                active={queryDraft.id === props.queryId}
                            >
                                {queryDraft.name}
                            </QueryLink>
                        ))}
                    </>
                )}
            </Preloader>
        </Sidebar>
    );
}
